// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-chat-conversation-settings-menu .conversation-controls {
  float: right;
}
.fi-chat-conversation-settings-menu .conversation-controls .fi-content-card-top-button {
  width: 24px;
  height: 24px;
  line-height: 16px;
  font-size: 18px;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-settings-menu/fi-chat-conversation-settings-menu.component.scss"],"names":[],"mappings":"AACI;EACI,YAAA;AAAR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAAZ","sourcesContent":[".fi-chat-conversation-settings-menu {\r\n    .conversation-controls {\r\n        float: right;\r\n\r\n        .fi-content-card-top-button {\r\n            width: 24px;\r\n            height: 24px;\r\n            line-height: 16px;\r\n            font-size: 18px;\r\n            margin-left: 5px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
